<template>
    <div>
        <div v-show="!isMounted" style="background-color: #0168b7; width: 100vw; height: 100vh; position: relative;">
            <v-img v-bind:src="require('./assets/images/securite_logo_white.png')" width="95" height="26.4" alt="セキュリテ"
                style="position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%); -webkit-transform: translate(-50%, -50%); -ms-transform: translate(-50%, -50%);" />
        </div>
        <v-app v-show="isMounted">

            <v-app-bar :elevation="0" density="compact" app>
                <template v-slot:prepend>
                    <v-btn icon @click="$router.go(-1)">
                        <v-icon>mdi-arrow-left</v-icon>
                    </v-btn>
                </template>

                <v-app-bar-title class="text-center text-subtitle-2 mx-auto px-2">
                    {{ activePageTitle }}
                </v-app-bar-title>

                <template v-slot:append>
                    <v-btn icon @click="$router.go()">
                        <v-icon>mdi-reload</v-icon>
                    </v-btn>
                </template>
            </v-app-bar>

            <v-main>
                <router-view v-slot="{ Component }">
                    <transition name="" mode="out-in">
                        <!-- keep-aliveでコンポーネントが再利用される = ライフサイクルイベントは発生しない -->
                        <keep-alive>
                            <component :is="Component" :key="$route.fullPath" />
                        </keep-alive>
                    </transition>
                </router-view>
            </v-main>

            <PodcastPlayer :podcast-iframe="podcastIframe" :podcast-title="podcastTitle"></PodcastPlayer>

            <v-bottom-navigation v-model="activeMenu" bg-color="surface-variant" color="primary" elevation="0" height="74" app>
                <template v-for="menu in menus" :key="menu.locate">
                    <v-btn v-if="menu.locate == '/progressive/account' && accountBadge > 0" :value="menu.locate" :ripple="false" @click="activeMenu = menu.locate" :active="activeMenu === menu.locate">
                        <v-badge
                            :content="accountBadge"
                            :value="accountBadge"
                            color="error"
                            overlap
                        >
                            <v-icon>{{ menu.icon }}</v-icon>
                        </v-badge>
                        <span>{{ menu.name }}</span>
                    </v-btn>
                    <v-btn v-else :value="menu.locate" :ripple="false" @click="activeMenu = menu.locate" :active="activeMenu === menu.locate">
                        <v-icon>{{ menu.icon }}</v-icon>
                        <span>{{ menu.name }}</span>
                    </v-btn>
                </template>

            </v-bottom-navigation>

            <v-snackbar
                v-model="flushActive"
                :timeout="1500"
                color="primary-container"
                position="fix"
                style="bottom: 80px;"
                variant="flat"
            >
                <div class="text-center">
                    {{ flushMessage }}
                </div>
            </v-snackbar>
            
        </v-app>
    </div>
</template>

<style scoped>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

.v-app-bar {
    background-color: #0168b7 !important;
}

.v-app-bar * {
    color: #fff;
}

.v-btn {
    padding: 0 4px !important;
}

.v-bottom-navigation {
    padding-bottom: 10px;
}

</style>

<style>
@import "./assets/css/reset.css";
@import "./assets/css/common.css";
@import "./assets/css/transit.css";
@import "./assets/css/override.css";
@import "./assets/css/shape.css";

[v-cloak] {
    display: none;
}
</style>

<script>
import axios from 'axios'
import PodcastPlayer from './components/PodcastPlayer.vue';
import { ref, provide } from 'vue';

export default {
    name: 'App',
    components: {
        PodcastPlayer
    },
    computed: {
        activeMenu: {
            get() {
                return this.$store.getters.activeMenu
            },
            set(value) {
                this.$store.dispatch("setActiveMenu", value);
            }
        },
        activeTab: {
            get() {
                return this.$store.getters.activeTab
            },
            set(value) {
                this.$store.dispatch("setActivetab", value);
            }
        },
        activePageTitle: {
            get() {
                return this.$store.getters.activePageTitle
            },
            set(value) {
                this.$store.dispatch("setActivePageTitle", value);
            }
        },
        numberItemsInCart: {
            get() {
                return this.$store.getters.numberItemsInCart
            },
            set(value) {
                this.$store.dispatch("setNumberItemsInCart", value);
            }
        },
        accountBadge: {
            get() {
                return this.$store.getters.numberAcountBadge
            },
            set(value) {
                this.$store.dispatch("setAccountBadge", value);
            }
        },
        flushActive: {
            get() {
                return this.$store.getters.flushActive
            },
            set(value) {
                this.$store.dispatch("setFlushActive", value);
            }
        },
        flushMessage: {
            get() {
                return this.$store.getters.flushMessage
            }
        }
    },
    created() {
        //アクティブメニューの初期値を設定
        this.$store.dispatch("setActiveMenu", window.location.pathname);
    },
    watch: {
        activeMenu: function (to) {
            if (to) {
                this.$router.push(to)
            }
        }
    },
    data: () => ({
        isMounted: false,
        menus: [
            { locate: '/progressive', name: 'ホーム', icon: 'mdi-home' },
            { locate: '/progressive/search', name: '見つける', icon: 'mdi-magnify' },
            { locate: '/progressive/watch', name: 'ウォッチ', icon: 'mdi-heart' },
            { locate: '/progressive/account', name: 'アカウント', icon: 'mdi-account' }
        ]
    }),
    setup() {
        const podcastIframe = ref();
        const podcastTitle = ref();

        const setPodcast = (iframe, title) => {
        podcastIframe.value = '';
        podcastTitle.value = '';
        podcastIframe.value = iframe;
        podcastTitle.value = title;
        //.podcastAreaにopenクラスを付与
        document.querySelector('.podcastArea').classList.add('open');
        }
        provide('setPodcast', setPodcast);
        return { podcastIframe, podcastTitle }
    },    
    mounted() {

        (async () => {
            try{
                const response = await axios.get('/api/cart/list')
                console.log(response)
                this.numberItemsInCart = response.data.length

                const res2 = await axios.get('/api/account/badge')
                this.accountBadge = res2.data.length
            }catch(error){
                console.error(error)
            }
        })()

        setTimeout(() => {
            this.isMounted = true;
        }, 1000);
    }
}
</script>